import firebase from "../../firebase";

export default function(body) {
    return firebase.functions().httpsCallable("allFunctions")({
        funcRole: "officeAdmin",
        funcName: "stateDevice",
        data: body
    });
}